// Import model
import { FilterCatalogFeedRequest } from '../models/FilterCatalogFeedRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CatalogFeedCondition } from '../models/CatalogFeedCondition';
import { CatalogFeedFields } from '../models/CatalogFeedFields';
import { CatalogFeedIndexedFields } from '../models/CatalogFeedIndexedFields';

// Import dependency serializers (for complex types)
import { CatalogFeedConditionSerializer } from './CatalogFeedConditionSerializer';
import { CatalogFeedFieldsSerializer } from './CatalogFeedFieldsSerializer';
import { CatalogFeedIndexedFieldsSerializer } from './CatalogFeedIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCatalogFeedRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCatalogFeedRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCatalogFeedRequest instance
   */
  static deserialize(json: string): FilterCatalogFeedRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCatalogFeedRequest instance
   */
  static fromObject(obj: any): FilterCatalogFeedRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCatalogFeedRequest');
    }


    const instance: FilterCatalogFeedRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CatalogFeedIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CatalogFeedFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CatalogFeedConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCatalogFeedRequest instances
   */
  static deserializeArray(json: string): FilterCatalogFeedRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCatalogFeedRequest instance to a JSON string
   */
  static serialize(instance: FilterCatalogFeedRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCatalogFeedRequest instance to a plain object
   */
  static toObject(instance: FilterCatalogFeedRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CatalogFeedConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCatalogFeedRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCatalogFeedRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
